import NavbarController from '../components/sections/Navbar/NavbarController';
import ConferencePresenter from '../presenters/ConferencePresenter';
import ProgrammeController from '../pages/Programme/ProgrammeController.js';
import AppContext from '../core/AppContext';
import sections from './Sections';
import Layout from './Layout';
import { initAnimation } from '../animations/Animation';
import { initCountdown } from '../components/common/Countdown/Countdown';

export default class App {

    constructor() {
    }

    async loadConference() {

        const presenter = new ConferencePresenter();

        AppContext.conference =
            await presenter.getConference();

        return AppContext.conference;
    }

    async init() {

        const app = document.getElementById('app');

        const conference =
            await this.loadConference();

        const content = (
            await Promise.all(
                sections.map(
                    section =>
                        section({
                            conference
                        })
                )
            )
        ).join('');

        app.innerHTML =
            Layout(content, conference);

        initAnimation();
        // initCountdown();

        NavbarController();

        ProgrammeController(conference);
    }

}
